if(!Promise.withResolvers){
  Promise.withResolvers=function(){
    let resolve,reject;
    const promise=new Promise((res,rej)=>{resolve=res;reject=rej;});
    return {promise,resolve,reject};
  };
}

if(!Promise.try){
  Promise.try=function(callback,...args){
    return new Promise(resolve=>resolve(callback(...args)));
  };
}
